import { render, staticRenderFns } from "./WattSliderModule.vue?vue&type=template&id=28c32418&scoped=true&"
import script from "./WattSliderModule.vue?vue&type=script&lang=js&"
export * from "./WattSliderModule.vue?vue&type=script&lang=js&"
import style0 from "./WattSliderModule.vue?vue&type=style&index=0&id=28c32418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c32418",
  null
  
)

export default component.exports